<template>
<div class="chapter">
<div class="inner_page">
<p class="title-head">C<span class="small">ONTENTS</span></p>
<table>
<colgroup>
<col width="40px"/>
<col width="350px"/>
</colgroup>
<tbody>
<tr><td colspan="2"><span href="#/Title" title="Link target outside of Sample">Title Page</span></td></tr>
<tr><td colspan="2"><span href="#/Copyright" title="Link target outside of Sample">Copyright Page</span></td></tr>
<tr><td colspan="2"><span href="#/Dedication" title="Link target outside of Sample">Dedication</span></td></tr>
<tr><td colspan="2"><a href="#/Foreword#For">Foreword</a></td></tr>
<tr><td colspan="2"><span href="#/Acknowledgments#Ack" title="Link target outside of Sample">Acknowledgments</span></td></tr>
<tr><td colspan="2"><span href="#/Introduction#Intro" title="Link target outside of Sample">Introduction</span></td></tr>
<tr><td><span href="#/Chapter1#C1" title="Link target outside of Sample">1.</span></td><td><span href="#/Chapter1#C1" title="Link target outside of Sample">The Early Concert Venues</span></td></tr>
<tr><td><span href="#/Chapter2#C2" title="Link target outside of Sample">2.</span></td><td><span href="#/Chapter2#C2" title="Link target outside of Sample">The World-Famous Cleveland Agora</span></td></tr>
<tr><td><span href="#/Chapter3#C3" title="Link target outside of Sample">3.</span></td><td><span href="#/Chapter3#C3" title="Link target outside of Sample">The Big-Time Venues</span></td></tr>
<tr><td><span href="#/Chapter4#C4" title="Link target outside of Sample">4.</span></td><td><span href="#/Chapter4#C4" title="Link target outside of Sample">Downtown and Around Town</span></td></tr>
<tr><td><span href="#/Chapter5#C5" title="Link target outside of Sample">5.</span></td><td><span href="#/Chapter5#C5" title="Link target outside of Sample">Blossom Music Center</span></td></tr>
<tr><td><span href="#/Chapter6#C6" title="Link target outside of Sample">6.</span></td><td><span href="#/Chapter6#C6" title="Link target outside of Sample">Beachland Ballroom</span></td></tr>
<tr><td><span href="#/Chapter7#C7" title="Link target outside of Sample">7.</span></td><td><span href="#/Chapter7#C7" title="Link target outside of Sample">Music Box Supper Club</span></td></tr>
<tr><td><span href="#/Chapter8#C8" title="Link target outside of Sample">8.</span></td><td><span href="#/Chapter8#C8" title="Link target outside of Sample">Bars and Guitars</span></td></tr>
<tr><td><span href="#/Chapter9#C9" title="Link target outside of Sample">9.</span></td><td><span href="#/Chapter9#C9" title="Link target outside of Sample">Other Notable Venues</span></td></tr>
<tr><td><span href="#/Chapter10#C10" title="Link target outside of Sample">10.</span></td><td><span href="#/Chapter10#C10" title="Link target outside of Sample">Rock &amp; Roll Hall of Fame and Museum</span></td></tr>
<tr><td colspan="2"><span href="#/List_Of_Organizations#Log" title="Link target outside of Sample">List of Organizations</span></td></tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?117cde06